import * as React from "react"
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area"
import { useTheme } from "../../styles/ThemeProvider"
import { cn } from "../../lib/utils"

const ScrollArea = React.forwardRef(({ className, children, ...props }, ref) => {
  const { themeObject } = useTheme();
  
  const scrollAreaTokens = themeObject.components.scrollArea || {};
  
  const scrollAreaStyles = {
    position: 'relative',
    overflow: 'hidden',
  };

  const viewportStyles = {
    height: '100%',
    width: '100%',
    borderRadius: 'inherit',
  };

  return (
    <ScrollAreaPrimitive.Root
      ref={ref}
      className={cn("", className)}
      style={scrollAreaStyles}
      {...props}
    >
      <ScrollAreaPrimitive.Viewport style={viewportStyles}>
        {children}
      </ScrollAreaPrimitive.Viewport>
      <ScrollBar />
      <ScrollAreaPrimitive.Corner />
    </ScrollAreaPrimitive.Root>
  );
})
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName

const ScrollBar = React.forwardRef(({ className, orientation = "vertical", ...props }, ref) => {
  const { themeObject } = useTheme();
  
  const scrollBarTokens = themeObject.components.scrollArea?.scrollBar || {};
  
  const baseScrollBarStyles = {
    display: 'flex',
    touchAction: 'none',
    userSelect: 'none',
    transition: 'colors 0.2s ease-in-out',
  };

  const verticalStyles = {
    height: '100%',
    width: scrollBarTokens.width || '10px',
    borderLeft: `1px solid transparent`,
    padding: '1px',
  };

  const horizontalStyles = {
    height: scrollBarTokens.height || '10px',
    flexDirection: 'column',
    borderTop: `1px solid transparent`,
    padding: '1px',
  };

  const scrollBarStyles = {
    ...baseScrollBarStyles,
    ...(orientation === "vertical" ? verticalStyles : horizontalStyles),
  };

  const thumbStyles = {
    position: 'relative',
    flex: '1 1 0%',
    borderRadius: scrollBarTokens.thumbBorderRadius || themeObject.borderRadius?.full || '9999px',
    backgroundColor: scrollBarTokens.thumbColor || themeObject.colors.border.default,
  };

  return (
    <ScrollAreaPrimitive.ScrollAreaScrollbar
      ref={ref}
      orientation={orientation}
      className={cn("", className)}
      style={scrollBarStyles}
      {...props}
    >
      <ScrollAreaPrimitive.ScrollAreaThumb style={thumbStyles} />
    </ScrollAreaPrimitive.ScrollAreaScrollbar>
  );
})
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName

export { ScrollArea, ScrollBar }